'use strict';

var getPolyfill = require('./polyfill');
var define = require('define-properties');

module.exports = function shimEntries() {
	var polyfill = getPolyfill();
	define(Object, { entries: polyfill }, {
		entries: function testEntries() {
			return Object.entries !== polyfill;
		}
	});
	return polyfill;
};



//////////////////
// WEBPACK FOOTER
// ./~/object.entries/shim.js
// module id = 4361
// module chunks = 168707334958949